import React, { useState, useEffect } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide splash screen after animation completes (4 seconds)
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className="splash-screen">
      <div className="splash-container">
        <div className="logo-wrapper">
          <div className="glow"></div>
          
          <div className="logo-animation">
            <div className="bar bar-left"></div>
            <div className="bar-middle">
              <div className="bar s-top"></div>
              <div className="bar s-middle">
                <div className="center-dot"></div>
              </div>
              <div className="bar s-bottom"></div>
            </div>
            <div className="bar bar-right"></div>
          </div>
        </div>

        <div className="logo-text">SPENSPOT</div>
      </div>
    </div>
  );
};

export default SplashScreen;
